(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("bookNowProperty", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["bookNowProperty"] = factory(require("React"), require("ReactDOM"));
	else
		root["bookNowProperty"] = factory(root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__19__) {
return 